import React, { useState } from 'react';

import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import defaultClasses from '../../../../components/BobTableContextMenu.module.css';

const SiteContextMenu = ({
    dataItem,
    history,
    onPreviewWeatherData,
    setCoreSite,
    setDeleteSiteModalOpen,
    setSelectedSite,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleEditSite = site => {
        const path = '/v2/dashboard/core/entities/manage';

        const queryValues = queryString.parse(history.location.search);
        queryValues.entityType = 'site';
        queryValues.entityParent = site.client.id;
        queryValues.entityId = site.id;

        const queryValuesString = queryString.stringify(queryValues);
        history.push(`${path}?${queryValuesString}`);
        setCoreSite(site);
    };

    const handleDeleteSite = site => {
        setSelectedSite(site);
        setDeleteSiteModalOpen(true);
    };

    const handlePreviewWeather = site => {
        onPreviewWeatherData(site);
    };

    return (
        <React.Fragment>
            <Button
                aria-owns={open && 'render-props-menu'}
                aria-haspopup="true"
                onClick={handleOpen}
                className={defaultClasses.toggleButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                <MenuItem
                    onClick={() => handleEditSite(dataItem)}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <span className="material-icons-outlined md-18">
                        edit
                    </span>
                    Edit
                </MenuItem>
                <MenuItem
                    onClick={() => handleDeleteSite(dataItem)}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <span className="material-icons-outlined md-18">
                        do_not_disturb_on
                    </span>
                    Deactivate
                </MenuItem>
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={() => handlePreviewWeather(dataItem)}
                >
                    <span className="material-icons-outlined material-icon-size">
                        thermostat
                    </span>
                    Preview Weather Data
                </MenuItem> 
            </Menu>
        </React.Fragment>
    );
};

export default withRouter(SiteContextMenu);
